import { useContext } from 'react';
import { ComponentPropsContext } from 'js/components/hocs/withComponent/context';
import { TComponentPropsContext } from 'js/components/hocs/withComponent/types';

export const useComponentProps = <TProps extends object>() =>
    useContext<TComponentPropsContext<TProps>>(ComponentPropsContext);
